export default "/assets/modules/images/Recommendation-Social.svg?355b4b2663ee5ac18bbba6c2e759788f";